import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4e711c08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom-bar-container" }
const _hoisted_2 = { class: "bottom-bar" }
const _hoisted_3 = { class: "bottom-bar-left" }
const _hoisted_4 = { class: "bold" }
const _hoisted_5 = { class: "bottom-bar-term" }
const _hoisted_6 = { class: "bold green" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.text), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.termLabel), 1)
      ]),
      _createElementVNode("div", {
        class: "bottom-bar-right",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleAmountChange && _ctx.handleAmountChange(...args)))
      }, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.computedAmountValue(_ctx.amount)), 1)
      ])
    ])
  ]))
}